import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  TypeformRatingDistribution,
  TypeformSurveyReport
} from '@app/shared/models/typeform-survey-report.model';
import { SelectedRange } from '@app/shared/models/volume-dashboard.model';

@Component({
  selector: 'app-typeform-survey-report',
  templateUrl: './typeform-survey-report.component.html',
  styleUrl: './typeform-survey-report.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TypeformSurveyReportComponent {
  @Input() report: TypeformSurveyReport | null = null;
  @Input() selectedRange: SelectedRange | null = null;
  @Input() isLoading = false;

  get hasData(): boolean {
    return (this.report?.responseCount ?? 0) > 0;
  }

  get ratingDistribution(): TypeformRatingDistribution[] {
    return [...(this.report?.ratingDistribution ?? [])].reverse();
  }

  ratingStars(rating: number): string {
    return '★'.repeat(rating);
  }
}
